export default (context, inject) => {
  inject('chat', {
    show() {
      if (window.$zopim) {
        window.$zopim.livechat.window.show();
      }
    },
  });
}
